export const registerWizardPlugins = () => {};
